module.exports = __webpack_public_path__ + "img/logo-sozo-150.564a3876.png";